import { apiClient } from './apiClient';

export const getDashboardStats = async () => {
  const response = await apiClient.get('/api/v1/dashboard/stats');
  return (
    response.data?.data || {
      totalClients: 0,
      totalProducts: 0,
      pendingProducts: 0,
      pendingOrders: 0,
    }
  );
};

export const getRecentActivities = async ({ page = 1, perPage = 10 } = {}) => {
  const response = await apiClient.get('/api/v1/dashboard/activities', {
    params: { page, per_page: perPage },
  });
  return {
    data: response.data?.data || [],
    pagination: response.data?.pagination || {
      total: 0,
      page,
      per_page: perPage,
      last_page: 1,
    },
  };
};
